<template>
  <div class="icon">
    <img class="icon__img" v-if="picture" :src="picture" />
    <div class="icon__text" v-if="!picture && name">{{ name[0] }}</div>
    <img class="icon__sub" v-if="iconType === 'twitter'" src="@/client/assets/images/x-with-circle.svg" /><img
      class="icon__sub"
      v-if="iconType === 'instagram'"
      src="@/client/assets/images/instagram-with-circle.svg"
    /><img class="icon__sub" v-if="iconType === 'tiktok'" src="@/client/assets/images/tiktok-with-circle.svg" />
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.icon {
  position: relative;
  display: inline-block;
  width: 32px;
  min-width: 32px;
  height: 32px;
  min-height: 32px;
  overflow: hidden;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;

  &__img {
    width: 100%;
    border-radius: 50%;
  }

  &__text {
    font-size: 16px;
    line-height: 32px;
    color: white;
    text-align: center;
    background-color: $primary-color;
    border-radius: 50%;
  }

  &__sub {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 16px;
    height: 16px;
    color: #55acee;
    border-radius: 50%;
  }
}
</style>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    name: String,
    pictureUrl: String,
    iconType: String
  },
  computed: {
    picture() {
      if (!this.pictureUrl && this.iconType === 'twitter') {
        return require('@/client/assets/images/twitter_default_profile.png')
      } else if (!this.pictureUrl && this.iconType === 'instagram') {
        return require('@/client/assets/images/instagram_default_profile.png')
      } else if (!this.pictureUrl && this.iconType === 'tiktok') {
        return require('@/client/assets/images/tiktok_default_profile.png')
      } else {
        return this.pictureUrl
      }
    }
  }
})
</script>
